'use client';

import { createContext, useContext, useState } from 'react';

import { GalleryContextType } from '@/utils/types/GalleryContextType';

const ProductGalleryContext = createContext<GalleryContextType>({
  isGalleryOpen: false,
  toggleGallery: (state: boolean) => null,
});

export const ProductGalleryProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isGalleryOpen, setIsGalleryOpen] = useState(false);

  const toggleGallery = (state: boolean) => {
    setIsGalleryOpen(state);
  };

  return (
    <ProductGalleryContext.Provider value={{ isGalleryOpen, toggleGallery }}>
      {children}
    </ProductGalleryContext.Provider>
  );
};

export const useProductGallery = () => {
  return useContext(ProductGalleryContext);
};
